import React from 'react';
import P from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import getLangData from '../../../utils/getLangData';

const UserTypeContainer = ({ userTypes }) => {
  return (
    <>
      {userTypes.map((type, i) => {
        if (type === '0') return <Admin key={i}>{getLangData().profile_types.super}</Admin>;
        if (type === '1') return <Admin key={i}>{getLangData().profile_types.admin}</Admin>;
        if (type === '4') return <Customer key={i}>{getLangData().profile_types.customer}</Customer>;
        if (type === '3') return <Artisan key={i}>{getLangData().profile_types.artisan}</Artisan>;
        if (type === '5') return <Supplier key={i}>{getLangData().profile_types.supplier}</Supplier>;
        if (type === '6') return <Applicant key={i}>{getLangData().profile_types.applicant}</Applicant>;
        if (type === '7') return <Partner key={i}>{getLangData().profile_types.partner}</Partner>;
        return;
        if (type === '8')
          return <TrainingCenter key={i}>Training Center</TrainingCenter>;
        return;
      })}
    </>
  );
};

UserTypeContainer.propTypes = {
  userTypes: P.arrayOf(P.string).isRequired,
};

UserTypeContainer.defaultProps = {
  userTypes: null,
};

export default UserTypeContainer;

const global = css`
  display: inline-block;
  padding: 3px 5px;
  font-size: 84%;
  color: #fff;
  border-radius: 3px;
  margin-left: 4px;
  margin-bottom: 4px;
`;

const TrainingCenter = styled.span`
  ${global}
  background-color: #0077cc;
`;
// const Applicant = styled.span`
//   ${global}
//   background-color: #000000;
// `;

const Admin = styled.span`
  ${global}
  background-color: #1d1b3cb3;
`;
const Customer = styled.span`
  ${global}
  background-color: #5d78ff;
`;
const Artisan = styled.span`
  ${global}
  background-color: #5a5b82;
`;
const Supplier = styled.span`
  ${global}
  background-color: cadetblue;
`;
const Applicant = styled.span`
  ${global}
  background-color: #ecc063;
`;

const Partner = styled.span`
  ${global}
  background-color: #0077cc;
`;

/**
 *   0 -  "Admin"
 *   4 -  "Customer"
 *   3 -  "Artisan"
 */
